import { render } from "./detail.vue?vue&type=template&id=2e4b3bb3&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=2e4b3bb3&lang=scss&scoped=true"

import exportComponent from "D:\\project\\dongmeng\\meeting-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e4b3bb3"]])

export default __exports__